import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'feeStructure',
    'additionalPaymentEditBtn',
    'createAdditionalPaymentModal',
    'modifyAdditionalPaymentId',
    'modifyAdditionalPaymentFormEmployee',
    'modifyAdditionalPaymentFormAmount',
    'modifyAdditionalPaymentFormReason',
    'modifyAdditionalPaymentFormPayableYes',
    'modifyAdditionalPaymentFormPayableNo',
    'overrideEmployee',
    'overrideAdditions',
    'overrideAdditionsYes',
    'overrideAdditionsNo',
    'overridePenalties',
    'overridePenaltiesYes',
    'overridePenaltiesNo',
    'paymentSpinner',
    'paymentFee'
  ]

  connect() {
    console.log("connected to Payments");
  }

  // [WORK IN PROGRESS]
  formChanged(){
    var dispute_resolution_submit_btm = $('#dispute-resolution-submit-btm')[0];
    var formatting_penalty_checkbox = $('#formatting-checkbox')[0];
    var plagiarism_penalty_checkbox = $('#plagiarism-checkbox')[0];
    var delivery_penalty_checkbox = $('#delivery-checkbox')[0];
    var deny_yes = $('#denyYes')[0];
    var deny_no = $('#denyNo')[0];

    //if deny all then all must be unchecked
    if (deny_yes.checked == true) {
      formatting_penalty_checkbox.checked = false;
      plagiarism_penalty_checkbox.checked = false;
      delivery_penalty_checkbox.checked = false;
    }


    // only if the firm has something filled that the submit button becomes available
    if (formatting_penalty_checkbox.checked || plagiarism_penalty_checkbox.checked || delivery_penalty_checkbox.checked || deny_yes.checked) {
      dispute_resolution_submit_btm.disabled = false;
    } else {
      dispute_resolution_submit_btm.disabled = true;
    }

  }

  // [WORK IN PROGRESS]
  modify(){
    var order_id = this.targets.find("paymentDetails").dataset.orderid;
    var formattingPenalties = this.targets.find("paymentDetails").dataset.formattingPenalties;
    var plagiarismPenalties = this.targets.find("paymentDetails").dataset.plagiarismPenalties;
    var plagiarismCost = this.targets.find("paymentDetails").dataset.plagiarismCost;
    var deliveryPenalties = this.targets.find("paymentDetails").dataset.deliveryPenalties;

    console.log(`for order ${order_id}`);

    // display penalties after remove the currency
    if (( formattingPenalties.replace(/[^0-9.-]+/g,"")) > 0 ) {
      $('#formatting-penalty-value').text(formattingPenalties);
      $('#formatting-field').show();
    } else {
      $('#formatting-penalty-value').text("");
      $('#formatting-field').hide();
    }
    // console.log(`formatting penalties ${formattingPenalties}`);

    if (( plagiarismPenalties.replace(/[^0-9.-]+/g,"")) > 0 ) {
      $('#plagiarism-penalty-value').text(plagiarismPenalties);
      $('#plagiarism-field').show();
    } else {
      $('#plagiarism-penalty-value').text("");
      $('#plagiarism-field').hide();
    }
    // console.log(`plagiarism penalties ${plagiarismPenalties}`);

    if (( deliveryPenalties.replace(/[^0-9.-]+/g,"")) > 0 ) {
      $('#delivery-penalty-value').text(deliveryPenalties);
      $('#delivery-field').show();
    } else {
      $('#delivery-penalty-value').text("");
      $('#delivery-field').hide();
    }
    // console.log(`delivery penalties ${deliveryPenalties}`);

    if (( plagiarismCost.replace(/[^0-9.-]+/g,"")) > 0 ) {
      $('#plagiarism-cost-value').text(plagiarismCost);
      $('#plagiarism-cost-field').show();
    } else {
      $('#plagiarism-cost-value').text("");
      $('#plagiarism-cost-field').hide();
    }
    console.log(`plagiarism-cost penalties ${plagiarismCost}`);

    // display the form
    $('#dispute-order-id')[0].value = order_id;
    $('#request-model-payment-modification-modal').modal('toggle');
  }

  // [WORK IN PROGRESS]
  showDisputedPenalties(dispute_details) {
    if ( dispute_details.includes('formatting') ) {
      $('#formatting-field').show();
    }
    if ( dispute_details.includes('plagiarism') ) {
      $('#plagiarism-field').show();
    }
    if ( dispute_details.includes('delivery') ) {
      $('#delivery-field').show();
    }
  }

  // [WORK IN PROGRESS]
  paymentDisputeResolution() {
    var dispute_id = this.targets.find("disputeDetails").dataset.dispute_id;
    var dispute_reason = this.targets.find("disputeDetails").dataset.dispute_reason;
    var dispute_details = this.targets.find("disputeDetails").dataset.dispute_details;

    this.showDisputedPenalties(dispute_details);
    $('#dispute-id')[0].value = dispute_id;
    $('#model-dispute-reason')[0].textContent = dispute_reason;
    $('#payment-dispute-resolve-modal').modal('toggle');
  }

  // Calculates the payment fees for the total payout amount
  //
  // @param feeJson [JSON] generated by the employee model
  //     feel_type [String] type of the fee, percent or fixed
  //     fee_rate [String] number value of the fee
  // @param payout_total [Float] payout total amount of all
  //     the orders
  //
  // @return [Float] value of the fees
  getFeeAmount(feeJson, payout_total){
    var feeType = feeJson["fee_type"];
    var rate = feeJson["fee_rate"]["rate"];
    var cap = feeJson["fee_rate"]["cap"];

    if (feeType == "percent") {
      var fees = parseFloat(payout_total * rate);
      if (fees > cap ) {
        return this.roundNum(24, 2)
      } else {
        return this.roundNum(fees, 2);
      }
    } else {
      return rate;
    }
  }

  // Calculates the payout and fees and prepares the datasets for
  //    payout submission.
  //
  // triggered by checking the reports on and off
  // sums all checked reports
  // datasets the order_ids that are collected
  // datasets the additional_payment_ids that are collected
  // in preperation for submission
  calculatedPayout() {
    // TODO:refactor @Raed
    var feeStructure = this.targets.find("paymentFee").dataset.feestructure;
    var payoutTotal = 0.00;
    var $total = $('#payments-total')[0];
    var $payoutController = $('.paypal-controller');
    var $payoutFee = $('#payments-fees')[0];
    var ordersArray = [];
    var additionalPaymentsArray = [];
    var selectedReports = $('.order-payment:checkbox:checked');
    var fee;

    for (let index = 0; index < selectedReports.length; index++) {
      const element = selectedReports[index];
      if ( element.id == "primary-payment" ) {
        ordersArray.push(element.dataset.order_id);
        payoutTotal += parseFloat(element.dataset.amount.replace("$",""));
      } else if ( element.id == "additional-payment" ) {
        additionalPaymentsArray.push(element.dataset.additional_payment_id);
        payoutTotal += parseFloat(element.dataset.amount.replace("$",""));
      }
    }

    fee = this.getFeeAmount(JSON.parse(feeStructure), payoutTotal);

    $payoutFee.innerHTML = fee;
    $total.innerHTML = "$"+this.roundNum((payoutTotal - fee),2);
    $total.dataset.orderids = ordersArray;
    $total.dataset.additionalpaymentids = additionalPaymentsArray;

    if (payoutTotal > 0 ){
      $payoutController.show();
    } else {
      $payoutController.hide();
    }
  }

  // Displays a modal to ward of a missing payment email so manager or employee
  //    are able to fill it out. payment submissions wont work without
  //    paypal email
  //
  // Toggles the modal on and sets the link to the employee profile
  missingPaypalEmail() {
    var employeeProfile = this.targets.find("paymentDetails").dataset.employeeProfile;
    var employeeProfileLink = $('#missing-paypal-employee-profile')[0];
    employeeProfileLink.href = employeeProfile;
    $('#missingPaypalEmailModal').modal('toggle');
  }

  // Toggle spinner off
  // update modal with success
  notifyPayoutSuccess(){
    $('#modal-title')[0].innerHTML = "Payment Processed";
    $('#payment-spinner').remove();
    $('#payment-success').toggle('is-visible');
    $('#payment-success-btn').toggle('is-visible');
  }

  // Toggle spinner off
  // update modal with error messages
  notifyPayoutFail(data){
    $('#modal-title')[0].innerHTML = "Payment Collection Failed!";
    $('#paypal-error-name')[0].innerHTML = data.error_name;
    $('#paypal-error-message')[0].innerHTML = data.error_message;
    $('#paypal-error-bug-id')[0].innerHTML = data.error_debug_id;
    $('#payment-spinner').remove();
    $('#payment-fail').toggle('is-visible');
    $('#payment-fail-btn').toggle('is-visible');
  }

  beginProcessingPayment(){
    $('#order-payment-processing-modal').modal('toggle');
    $('#payment-spinner').toggle('is-visible');
  }

  // initiates paypal payout
  //
  // gets the order ids and the additional payment ids to recreate a ajax request
  // for the paypayl api
  collect() {
    var $collectPaymentBtn = $('#payment-collect-btn');
    var $total = $('#payments-total')[0];
    var employeeId = $total.dataset.employee;
    var orderIds = $total.dataset.orderids;
    var additionalPaymentIds = $total.dataset.additionalpaymentids;
    var ordersJson = JSON.stringify(Object.assign({}, orderIds.split(",")));
    var additionalPaymentsJson = JSON.stringify(Object.assign({}, additionalPaymentIds.split(",")));

    $collectPaymentBtn.remove();

    this.beginProcessingPayment();

    var that = this;

    setupAjax();
    $.ajax({
      url: "/payments/collect_payment",
      method: "POST",
      data: {
        payment: {
          o_ids: ordersJson,
          a_ids: additionalPaymentsJson,
          employee_id: employeeId
        }
      },
      success: function(_data) {
        if (_data.payment_status == "success") {
          that.notifyPayoutSuccess();
        } else {
          that.notifyPayoutFail(_data);
        }
      }
    });
  }

  // Displays the payment override modal with the correct employee preselected
  //
  // When override button is clicked on a specific employee in the payment panel in an order. This
  //  function pre-selects the employee that this override is meant for. once index of the employee
  //  is selected. It toggles to display the modal
  overridePayment(event){
    var employeeId = event.currentTarget.dataset.employeeId
    var employee = this.overrideEmployeeTarget
    var selectedEmployeeOption = employee.querySelectorAll(`option[value='${employeeId}']`);
    selectedEmployeeOption[0].selected = true;
    $('#paymentOverrideModal').modal('toggle');

    let employee_position = event.currentTarget.dataset.employeePosition;

    if (employee_position == "writer"){
      this.overrideAdditionsYesTarget.checked = false
      this.overrideAdditionsNoTarget.checked = false
      this.overrideAdditionsTarget.hidden = true;
    } else if (employee_position == 'qa_editor' || employee_position == 'qc_editor') {
      this.overrideAdditionsYesTarget.checked = false
      this.overrideAdditionsNoTarget.checked = false
      this.overrideAdditionsTarget.hidden = true;
      this.overridePenaltiesYesTarget.checked = false
      this.overridePenaltiesNoTarget.checked = false
      this.overridePenaltiesTarget.hidden = true;
    } else {
      this.overrideAdditionsYesTarget.checked = true
      this.overrideAdditionsNoTarget.checked = false
      this.overrideAdditionsTarget.hidden = false;
    }

  }

  // Marks order payment as requested for payout. This is initiated by the
  //    Urbanite when they are ready to be paid out for an order.
  //
  // @param OrderID [String] id of the Order
  // @param employeeID [String] id of the Employee
  requestOrderPayout(event) {
    var orderID = event.currentTarget.dataset.order_id
    var employeeID = event.currentTarget.dataset.employee_id

    setupAjax();
    $.ajax({
      url: "/payments/request_order_payout",
      method: "POST",
      data: {
        order: {
          order_id: orderID,
          employee_id: employeeID
        },
      },
      dataType: "json",
      success: function(data) {
        if (data.status == "fail") {
          alert(data.message)
        } else {
          console.log("clicked");
          $(`#request-payout-${data.order_id}`)[0].style = "pointer-events:none;";
          $(`#request-payout-${data.order_id}`)[0].children[0].style.color = "";
        };
      }
    });
  }

  // Marks order payment as requested for payout. This is initiated by the
  //    Urbanite when they are ready to be paid out for an order.
  //
  // @param AdditionalPaymentID [String] id of the Order
  requestAdditionalPaymentPayout(event) {
    var additionalPaymentId = event.currentTarget.dataset.additional_payment_id

    setupAjax();
    $.ajax({
      url: "/payments/request_additional_payment_payout",
      method: "POST",
      data: {
        additional_payment: {
          additional_payment_id: additionalPaymentId
        },
      },
      dataType: "json",
      success: function(data) {
        if (data.status == "fail") {
          alert(data.message)
        } else {
          $(`#request-payout-${data.order_id}`)[0].style = "pointer-events:none;"
          $(`#request-payout-${data.order_id}`)[0].children[0].style.color = ""
        };
      }
    });
  }

  // Auto checks and unchecked all order checkboxes for easy select all User interface
  selectAllPayouts() {
    var selectAllPayouts = $('.select-all-payouts')[0]

    if (selectAllPayouts.checked) {
      $('.order-payment').prop("checked", true);
    } else {
      $('.order-payment').prop("checked", false);
    }

    this.calculatedPayout()
  }

  // fills the additional payment for and displays the modal
  //
  // @param event [DOM event] to identify which additional payment is requesting to edit
  //
  // @return change html and display the modal
  editAdditionalPayment(event){
    var details = event.currentTarget.dataset.details;
    details = details.replaceAll('%20',' ');
    var additionalPaymentJson = JSON.parse(details);
    var additionalPaymentModal = $('#modifyAdditionalPaymentModal');

    this.modifyAdditionalPaymentIdTarget.value = additionalPaymentJson.id;
    this.modifyAdditionalPaymentFormEmployeeTarget.value = additionalPaymentJson.employee_id;
    this.modifyAdditionalPaymentFormAmountTarget.value = additionalPaymentJson.amount;
    this.modifyAdditionalPaymentFormReasonTarget.value = additionalPaymentJson.reason;

    if (additionalPaymentJson.payable){
      this.modifyAdditionalPaymentFormPayableYesTarget.checked = true
      this.modifyAdditionalPaymentFormPayableNoTarget.checked = false
    } else {
      this.modifyAdditionalPaymentFormPayableNoTarget.checked = true
      this.modifyAdditionalPaymentFormPayableYesTarget.checked = false
    }

    additionalPaymentModal.modal();
  }

  // updates the total amount of the report headers and removes the order row
  //
  // @param current_tr [HTML element] order row to be removed
  // @param cardHeading [HTML element] header of the report to be updates with new total
  // @param orderAmount [Float] order amount that is to be subtracted from the total
  //
  // @return update the HTML elemnent of the unpaid report
  updateReport(current_tr, cardHeading, orderAmount){
    var reportTotalSpan = cardHeading.querySelector('.report-total')

    current_tr.remove();
    total = parseFloat(reportTotalSpan.innerText)
    total -= orderAmount
    reportTotalSpan.innerText = this.roundNum(total, 2)
  }

  // rounds 2 decimal places numbers up for 5 and and down for 4
  // e.g 1.275 is 1.28 and 1.274 is 1.27
  //
  // @param amount [String] to which to convert to value with 2 decimal places
  //
  // @return [String] the rounded number
  roundNum(num, precision) {
    return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
  }

  // Marks order as paid
  //
  // @param details [Order as JSON] order to be marked as paid attributes
  //
  // @return [js Alert] result of mark paid success of fail
  markOrderAsPaid(event) {
    $('#kt_content').append(spinner());
    let markPaidBtn = event.target

    if (markPaidBtn.disabled != true){
      markPaidBtn.disabled = true;
      let details = event.currentTarget.dataset.details;
      details = JSON.parse(details.replaceAll('%20',' '));

      let orderID = details.order_id;
      let employeeID = details.employee_id;
      let employeeSlug = details.employee_slug;
      let current_tr = event.currentTarget.parentElement.parentElement.parentElement;
      let orderAmount = parseFloat(details.total.replace('$',''));
      let cardHeading = $(`#heading${employeeSlug}`)[0];
      let editor_type = details.editor_type;

      let that = this;

      setupAjax();
      $.ajax({
        url: "/orders/mark_paid",
        method: "POST",
        data: {
          order: {
            id: orderID
          },
          employee: {
            id: employeeID
          },
          editor_type: editor_type
        },
        success: function (data) {
          $('.spinner-primary').remove();
          that.updateReport(current_tr, cardHeading, orderAmount);
        },
        error: function (data) {
          $('.spinner-primary').remove();
          markPaidBtn.disabled = false;
          alert("Failed to mark order as paid, Please try again!")
        },
      });
    }
  }

  // Marks additional payment as paid
  //
  // @param additionalPaymentId [String] id of the additional payment to be marked as paid
  // @param employeeId [String] empployee to that additional payment belongs to
  //
  // @return [js Alert] result of mark paid success of fail
  markAdditionalPaymentAsPaid(event) {
    $('#kt_content').append(spinner());

    var markPaidBtn = event.target

    if (markPaidBtn.disabled != true){
      markPaidBtn.disabled = true;
      var additionalPaymentId = event.currentTarget.dataset.additionalpaymentid
      var employeeID = event.currentTarget.dataset.employeeid
      var current_tr = event.currentTarget.parentElement.parentElement.parentElement;
      var orderAmount = parseFloat(event.currentTarget.dataset.additionalpaymentamount.replace('$',''))
      var cardHeading = $(`#heading${employeeID}`)[0]

      var that = this;

      setupAjax();
      $.ajax({
        url: "/orders/mark_paid_additional_payment",
        method: "POST",
        data: {
          additional_payment: {
            id: additionalPaymentId
          },
          employee: {
            id: employeeID
          }
        },
        success: function (data) {
          $('.spinner-primary').remove();
          that.updateReport(current_tr, cardHeading, orderAmount);
        },
        error: function (data) {
          $('.spinner-primary').remove();
          markPaidBtn.disabled = false;
          alert("Failed to mark additional payment as paid, Please try again!");
        },
      });
    }
  }

  // Marks all orders and additional payments in the view as paid
  //
  // @param employeeId [String] employee of that payments
  // @param employeeName [String] employee name to display the name in the alerts for confirmation
  //
  // @return [js Alert] result of mark paid success or fail
  markAllAsPaid(event){
    $('#kt_content').append(spinner());
    var employeeName = event.currentTarget.dataset.employeeName

    if (confirm(`Are you sure you want mark ${employeeName}'s all payments as paid?`)) {
      event.currentTarget.disabled = true;
      var employeeId = event.currentTarget.dataset.employeeId
      var cardHeading = $(`#heading${employeeId}`)

      setupAjax();
      $.ajax({
        url: "/orders/mark_all_unpaid_as_paid",
        method: "POST",
        data: {
          employee: {
            id: employeeId
          },
          mark_paid: {
            ids_json: event.currentTarget.dataset.markPaidIds,
          },
        },
        success: function (data) {
          $('.spinner-primary').remove();
          alert(`Marked all payments for ${employeeName}'s as paid!`)
          $('.payment-reports').remove();

          if (cardHeading.length > 0){
            var headingText = cardHeading[0].innerText.split('$')[0]
            cardHeading[0].children[0].innerText = headingText + '$0.00'
          }
        },
        error: function (data) {
          $('.spinner-primary').remove();
          alert("Failed to mark payments as paid, Please try again!")
        },
      });
    }
  }
}